import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import withStyles from '@mui/styles/withStyles'

import AcquiringApi from 'components/core/Acquiring/AcquiringApi'
import AcquiringDashboard from 'components/core/Acquiring/AcquiringCharges'
import AcquiringOverview from 'components/core/Acquiring/AcquiringOverview'
import AcquiringSettlements from 'components/core/Acquiring/AcquiringSettlements'
import Tabs from 'components/core/Acquiring/AcquiringTabs/components/Tabs'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { RootState } from 'redux/store'
import { themeStyles } from 'themes'

interface AcquiringTabsProps {
    classes: any
    currentValue: number
}

const AcquiringTabs: React.FC<AcquiringTabsProps> = ({ classes, currentValue }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { componentName }: any = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const parentPath = location?.pathname?.split('/')?.[1]

    const [value, setValue] = React.useState(currentValue)

    const acquiringError = useSelector((state: RootState) => state.acquiring.error)

    const tabs: TabData[] = [
        {
            id: 0,
            name: 'overview',
            label: t('Acquiring.Overview'),
            Component: AcquiringOverview,
            disabled: false,
            hidden: false,
        },
        {
            id: 1,
            name: 'charges',
            label: t('Acquiring.Charges'),
            Component: AcquiringDashboard,
            disabled: false,
            hidden: false,
        },
        {
            id: 2,
            name: 'settlements',
            label: t('Acquiring.Settlements'),
            Component: AcquiringSettlements,
            disabled: false,
            hidden: false,
        },
        {
            id: 3,
            name: 'api',
            label: t('Acquiring.API'),
            Component: AcquiringApi,
            disabled: false,
            hidden: false,
        },
    ]

    useEffect(() => {
        if (componentName) {
            const currentTab = tabs?.find(o => o?.name === componentName)

            if (currentTab?.disabled) {
                navigate(`/${parentPath}/${tabs?.[0]?.name}`, { replace: true })
            } else {
                setValue(currentTab?.id)
            }
        }
    }, [componentName, parentPath, tabs])

    const handleChange = (_event: React.ChangeEvent, newValue: number) => {
        !!acquiringError && dispatch(finishErrorAlert()) //clear Acquiring errors, if any
        const newTab = tabs?.find(o => o.id === newValue)?.name

        navigate(`/${parentPath}/${newTab}`)
    }

    return <Tabs tabs={tabs} classes={classes} currentTabIndex={value} onTabChange={handleChange} />
}

export default withStyles(themeStyles.useModalStyles)(AcquiringTabs)
